import {withFormik} from "formik";
import * as yup from "yup"
import {englishCharRegExp} from "../../../services/regex"
import {isNotEmpty} from "../../../helpers/functions";
import httpClient from "../../../services/httpClient";
import {blogsApi, videoProductApi} from "../../../constans/apiUrls";
import {
    BlogFileType,
    ClassStatusVideoProduct,
    StatusVideoProduct,
    TypeVideoProduct,
    VideoLinkType
} from "../../../constans/enumTypes";
import InnerVideoProductForm from "../../../components/FormTemplates/video_product/InnerVideoProductForm";
import {IVideoProductData} from "../../../contracts/data/video_product";


const videoProductFormValidationSchema = yup.object().shape({
    product: yup.number().required("محصول الزامی میباشد").min(1, "محصول الزامی میباشد"),
    banner: yup.string().required("عکس بنر الزامی میباشد"),
})

interface IVideoProductFormProps {
    formType?: string,
}

const VideoProductForm = withFormik<IVideoProductFormProps, IVideoProductData>({
    mapPropsToValues: props => ({
        id: 0,
        product: 0,
        type_video: TypeVideoProduct.PRODUCT,
        status_product: StatusVideoProduct.REGISTERING,
        class_link: '',
        class_help_link: '',
        status_class: ClassStatusVideoProduct.PERFORMING,
        type_trailer: VideoLinkType.LINK,
        trailer_video: '',
        banner: '',
        summary: '',
        description: '',
        is_counseling: false,
    }),
    mapPropsToStatus: props => ({
        formType: props.formType,
    }),
    validationSchema: videoProductFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        const formData = new FormData();
        if (values.banner && isNotEmpty(values.banner) && typeof values.banner === 'object') {
            formData.append('banner', values.banner)
        }
        formData.append('data', JSON.stringify(values))

        if (formikBag.props.formType === 'create') {
            await httpClient().post(videoProductApi.create, formData)
                .then(response => {
                    if(response.status === 201 || response.status === 200 ){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        } else if (formikBag.props.formType === 'edit') {
            await httpClient().put(`${videoProductApi.update}/${values.id}`, formData)
                .then(response => {
                    if(response.status === 200){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        }
    },
    displayName: 'VideoProductForm'
})(InnerVideoProductForm)

export default VideoProductForm